Jelly.Utilities.Detect_Feature = function (Feature) {
  switch (Feature.toLowerCase()) {
    // https://github.com/Modernizr/Modernizr/blob/6d56d814b9682843313b16060adb25a58d83a317/feature-detects/storage/cookies.js
    case 'cookies':
      try {
        // Create cookie
        document.cookie = 'cookietest=1';
        var ret = document.cookie.indexOf('cookietest=') !== -1;
        // Delete cookie
        document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT';
        return ret;
      }
      catch (e) {
        return false;
      }
      break;

  	case 'is_android_pixel_2_instagram':
  		if (/Android/.test(navigator.userAgent) && /Instagram/.test(navigator.userAgent) && /Pixel 2/.test(navigator.userAgent))
  			return true;
  		else
  			return false;
  		break;

    case 'is_older_ie':
      return (/MSIE|Trident/.test(navigator.userAgent) && !/11.0/.test(navigator.userAgent) && !/Edg/.test(navigator.userAgent));
      break;

    case 'is_facebook':
      var ua = navigator.userAgent || navigator.vendor || window.opera;
      return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
      break;

    case 'emoji':
      var emojiSupported = (function() {
        var node = document.createElement('canvas');
        if (!node.getContext || !node.getContext('2d') ||
            typeof node.getContext('2d').fillText !== 'function')
          return false;
        var ctx = node.getContext('2d');
        ctx.textBaseline = 'top';
        ctx.font = '32px Arial';
        ctx.fillText('\ud83d\ude03', 0, 0);
        return ctx.getImageData(16, 16, 1, 1).data[0] !== 0;
      })();
      return emojiSupported; 
    break;
  }
  return false;
};